// extracted by mini-css-extract-plugin
module.exports = {"container":"ProductsIndex_container__W8ykG","heading":"ProductsIndex_heading__2oZG3","cards":"ProductsIndex_cards__3zPfO"};